export const dataCodeApi = {
  listPackages: '/clouddm/console/api/v1/datahandle/package/listpkg',
  uploadPackage: '/clouddm/console/api/v1/datahandle/package/upload',
  deletePackageAndBind: '/clouddm/console/api/v1/datahandle/package/deletePkgAndBind',
  downloadPkg: '/clouddm/console/api/v1/datahandle/package/download',
  updatePkgInfo: '/clouddm/console/api/v1/datahandle/package/updateInfo',
  updatePackage: '/clouddm/console/api/v1/datahandle/package/updatepkg'
};
